import { DateTime, Interval } from 'luxon';

import { WarehouseOrDepotInput__Kind } from '@admin/schema';

/** Clock-in distance is serialized from Postgres decimal and may arrive as a string. */
export const clockinDistanceMiles = (distance: number | string | null | undefined): number => {
  const miles = Number(distance);
  return Number.isFinite(miles) ? miles : 0;
};

export const getWarehouseOrDepotInput = (splittableFacilityID?: string | null) => {
  if (!splittableFacilityID) {
    return undefined;
  }

  const [facilityType, rawFacilityID] = splittableFacilityID.split('/');

  if (facilityType && rawFacilityID) {
    return {
      id: rawFacilityID,
      type: facilityType === 'Warehouse' ? WarehouseOrDepotInput__Kind.Warehouse : WarehouseOrDepotInput__Kind.Depot,
    };
  } else {
    return undefined;
  }
};

const getIntervalInMinutes = (started: string | DateTime, ended: string | DateTime) =>
  Interval.fromDateTimes(
    started instanceof DateTime ? started : DateTime.fromISO(started),
    ended instanceof DateTime ? ended : DateTime.fromISO(ended),
  ).length('minutes');

export const calculateDuration = (
  started: string | DateTime,
  ended: string | DateTime,
  workBreaks: Array<{ started?: string | DateTime | null; ended?: string | DateTime | null }>,
) => {
  let duration = 0;
  if (started && ended) {
    const shiftLength = getIntervalInMinutes(started, ended);
    const breakLength =
      workBreaks
        .filter((wb) => wb.started && wb.ended)
        .reduce((minutes, wb) => minutes + getIntervalInMinutes(wb.started as string, wb.ended as string), 0) || 0;
    duration = shiftLength > breakLength ? shiftLength - breakLength : 0;
  }
  return Math.ceil(duration);
};
